import styled, { css } from 'styled-components';

export const TextLog = styled.span`
  color: ${({ color }) => (color ? color : '#000')};
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  ${(props) =>
    !!props.isInfo &&
    css`
      font-weight: 400;
    `};
`;
